import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { IGetAllServiceProps } from "@api/types/globalService.types";
import { useQuery } from "@tanstack/react-query";
import { getAllConsentAPI, getSingleConsentAPI } from "./consent.api";
import useGlobalDebounceHandler from "../useGlobalDebounceHandler";
import { useState } from "react";

type IConsentServiceProps = Omit<IGetAllServiceProps, "stage_id">;

const useAllConsentService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters,
}: IConsentServiceProps) => {
  const [searchConsentQuery, setSearchConsentQuery] = useState<string>("");

  const { debouncedQuery } = useGlobalDebounceHandler(searchConsentQuery);
  const allConsentService = useQuery({
    queryKey: [...CACHE_KEYS.CONSENT, page, per_page, ...cacheKeys],
    queryFn: () =>
      getAllConsentAPI({
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });

  return {
    states: { searchConsentQuery, setSearchConsentQuery },
    services: { allConsentService },
  };
};

const useSingleConsentService = ({
  singleConsentId,
  enableQuery = true,
}: {
  singleConsentId: string;
  enableQuery?: boolean;
}) => {
  return useQuery({
    queryKey: [...CACHE_KEYS.CONSENT, singleConsentId],
    queryFn: () => getSingleConsentAPI(singleConsentId),
    enabled: !!singleConsentId && enableQuery,
  });
};

export { useAllConsentService, useSingleConsentService };
